<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店进销存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowMenDianSelect">
            <el-select v-model="keywords.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianChanPingLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.guige" @keyup.enter.native="clicksearch" placeholder="请输入规格/型号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" :cell-style="{padding: '0'}" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Leibie" label="类别" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="名称" min-width="10%"></el-table-column>
          <el-table-column prop="Guige" label="规格/型号" min-width="10%"></el-table-column>
          <el-table-column prop="Caigoudanjia" label="采购单价" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowDanJia"></el-table-column>
          <el-table-column prop="Dlsdanjia" label="代理商单价" min-width="10%" ></el-table-column>
          <el-table-column prop="Saledanjia" label="建议零售单价" min-width="10%" ></el-table-column>
          <el-table-column prop="Caigoushuliang" label="采购数量" min-width="10%"></el-table-column>
          <el-table-column prop="Caigouchengben" label="采购成本" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowDanJia"></el-table-column>
          <el-table-column prop="Lingyongshuliang" label="领用数量" min-width="10%"></el-table-column>
          <el-table-column prop="Lingyongchengben" label="领用成本" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowDanJia"></el-table-column>
          <el-table-column prop="Xiaoshoushuliang" label="销售数量" min-width="10%"></el-table-column>
          <el-table-column prop="Xiaoshouchengben" label="销售成本" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowDanJia"></el-table-column>
          <el-table-column prop="Xiaoshoujine" label="销售金额" min-width="10%"></el-table-column>
          <el-table-column prop="Kucunshuliang" label="库存数量" min-width="10%"></el-table-column>
          <el-table-column prop="Kucunchengben" label="库存成本" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCun_ShowDanJia"></el-table-column>
          <el-table-column label="操作" min-width="20%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="KuCunOutUse(scope.row)">领用出库</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="KuCunOutSale(scope.row)">销售出库</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="领用出库" name="second" disabled="disabled">
        <MenDianPurchaseSalesKuCunOutUse ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></MenDianPurchaseSalesKuCunOutUse>
      </el-tab-pane>

      <el-tab-pane label="销售出库" name="three" disabled="disabled">
        <MenDianPurchaseSalesKuCunOutSale ref="SubVuethree" v-on:triggerFunc="BackToFirst"></MenDianPurchaseSalesKuCunOutSale>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import MenDianPurchaseSalesKuCunOutUse from '@/componentsSubVue/MenDianPurchaseSalesKuCunOutUse.vue'
import MenDianPurchaseSalesKuCunOutSale from '@/componentsSubVue/MenDianPurchaseSalesKuCunOutSale.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    MenDianPurchaseSalesKuCunOutUse,
    MenDianPurchaseSalesKuCunOutSale
  },
  name: 'MyMenDianPurchaseSalesKuCun',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        leibie: '',
        name: '',
        guige: '',
      },
      SubRule_MenDianPurchaseSalesKuCun_ShowDanJia: false,
      SubRule_MenDianPurchaseSalesKuCun_ShowMenDianSelect: false,
      RuiShiLiYanKeMenDian:[],
      RuiShiLiYanKeMenDianChanPingLeiBie:[],
    }
  },
  mounted () {
    this.RuiShiLiYanKeMenDian = Vue.prototype.FunGetRuiShiLiYanKeMenDian()
    this.RuiShiLiYanKeMenDianChanPingLeiBie = Vue.prototype.FunGetRuiShiLiYanKeMenDianChanPingLeiBie()
    this.keywords.jigouid = this.RuiShiLiYanKeMenDian[1].value
    this.apiMenDianPurchaseSalesKuCun()
    this.apiMenDianPurchaseSalesKuCunNum()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesKuCun_ShowDanJia', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MenDianPurchaseSalesKuCun_ShowDanJia = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesKuCun_ShowMenDianSelect', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MenDianPurchaseSalesKuCun_ShowMenDianSelect = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiMenDianPurchaseSalesKuCun()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiMenDianPurchaseSalesKuCun()
      this.apiMenDianPurchaseSalesKuCunNum()
    },
    clickexcel () {
      this.apiExcelMenDianPurchaseSalesKuCun()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiMenDianPurchaseSalesKuCun()
    },
    // 领用出库
    KuCunOutUse (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 销售出库
    KuCunOutSale (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    apiMenDianPurchaseSalesKuCun: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        name: that.keywords.name,
        guige: that.keywords.guige,
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_MenDianPurchaseSalesKuCun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiMenDianPurchaseSalesKuCunNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        name: that.keywords.name,
        guige: that.keywords.guige
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_MenDianPurchaseSalesKuCunNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelMenDianPurchaseSalesKuCun: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        name: that.keywords.name,
        guige: that.keywords.guige
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelMenDianPurchaseSalesKuCun, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
